
import React, { Component } from 'react'
import TextIput from '../../../textInput'
import validation, { notEmpty, emailAddres, isValid, justNumber, password } from '../../../validations'
import * as Notification from '../../../notification'
import $ from 'jquery'
var validationData = {
    firstName: [notEmpty],
    lastName: [notEmpty],
    email: [notEmpty, emailAddres],
    phone: [notEmpty, justNumber],
    password: [notEmpty, password],
    confirmPassword: [notEmpty]
}
export class StepOne extends Component {

    constructor(props) {
        super(props)
        this.state = {
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            password: "",
            confirmPassword: ""
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.partnerData != nextProps.partnerData) {
            this.setState({
                firstName: this.props.partnerData.firstName,
                lastName: this.props.partnerData.lastName,
                email: this.props.partnerData.email,
                phone: this.props.partnerData.phone,
            })
        }
    }
    componentDidMount() {
        if (this.props.partnerData)
            this.setState({
                firstName: this.props.partnerData.firstName,
                lastName: this.props.partnerData.lastName,
                email: this.props.partnerData.email,
                phone: this.props.partnerData.phone,
            })
    }

    handleSubmit() {
        Notification.hide();
        const businessValue = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            phone: this.state.phone,
            password: this.state.password,
            confirmPassword: this.state.confirmPassword
        }
        if (businessValue.password === businessValue.confirmPassword) {
            if (isValid(validationData))
                this.props.callback(businessValue);
        }
        else {
            Notification.show($("#confirmPassword"), "Comfirm password does not match.", "fail", "1");
        }
    }

    render() {
        return (
            <div className="step_1">
                <div className="step_intro">
                    <div className="step_header">
                        <p>Get Started</p>
                    </div>
                    <div className="step_decription">
                        <p>What are the benefits when joining Nails Spa of American Network?</p>
                        <p>1. Free POS Nails Salon Software</p>
                        <p>2. Your Salon get list on our nailspaofamerica.com website</p>
                        <p>3. Free Online Appointment Book</p>
                        <p>4. Free Website</p>
                        <p>5. Save money on Nails Supply</p>
                        <p>6. Free nganhnails APP</p>
                        <p>7. Marketing consultant</p>
                        <p>If you need help to setup POS, Website please call our experts <span>571-308-7777</span></p>
                    </div>
                </div>
                <div className="step_detail">
                    <div className="addmin_user">
                        <p>Create your first admin user.</p>
                        <TextIput
                            name="firstName"
                            label="First Name"
                            showLabel={true}
                            showPlaceholder={false}
                            value={this.state.firstName}
                            validations={validationData.firstName}
                            onChange={(value) => this.setState({
                                firstName: value
                            })}
                        />
                        <TextIput
                            name="lastName"
                            label="Last Name"
                            showLabel={true}
                            showPlaceholder={false}
                            value={this.state.lastName}
                            validations={validationData.lastName}
                            onChange={(value) => this.setState({
                                lastName: value
                            })}
                        />
                        <TextIput
                            name="email"
                            label="Email Address"
                            showLabel={true}
                            showPlaceholder={true}
                            placeholder="yourmail@example.com"
                            value={this.state.email}
                            validations={validationData.email}
                            onChange={(value) => this.setState({
                                email: value
                            })}
                        />
                        <TextIput
                            name="phone"
                            label="Phone"
                            showLabel={true}
                            showPlaceholder={false}
                            value={this.state.phone}
                            validations={validationData.phone}
                            isNumber={true}
                            onChange={(value) => this.setState({
                                phone: value
                            })}
                        />
                        <TextIput
                            name="password"
                            label="Password"
                            showLabel={true}
                            showPlaceholder={false}
                            isPassword={true}
                            value={this.state.password}
                            validations={validationData.password}
                            onChange={(value) => this.setState({
                                password: value
                            })}
                        />
                        <TextIput
                            name="confirmPassword"
                            label="Re-enter Password"
                            showLabel={true}
                            showPlaceholder={false}
                            isPassword={true}
                            value={this.state.confirmPassword}
                            validations={validationData.confirmPassword}
                            onChange={(value) => this.setState({
                                confirmPassword: value
                            })}
                        />
                    </div>
                    <div className="step_footer">
                        <button className="bt_next" onClick={() => this.handleSubmit()}>Next</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default StepOne


// WEBPACK FOOTER //
// ./src/components/partner/register/stepOne.js